module.exports = __webpack_public_path__ + "static/img/analise-sentimento-1.63f5793.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/analise-sentimento-1.png
// module id = /86C
// module chunks = 1